module.exports = __webpack_public_path__ + "media/images/powerpoint/landor-background-47bd3f759bca78c78c50ed56a115b1ba.png";